// Programme facts drawn from maplecc.ca (Admissions, Academic Calendar) and client briefing.
// Dates and fees change each year and are managed via the CMS.

export const ENROLMENT = {
  value: 360,
  suffix: "+",
  label: "Students enrolled since 2019",
  founded: 2019,
};

export type Intake = {
  month: string;
  name: string;
  summary: string;
  completes: string;
};

export const INTAKES: Intake[] = [
  {
    month: "September",
    name: "Fall intake",
    summary: "The main start of the academic year, aligned with Semester 1.",
    completes: "Grade 12 students complete their programme in June of the following year.",
  },
  {
    month: "January",
    name: "January intake",
    summary: "A second start for families who decide later, aligned with Semester 2.",
    completes: "Completion dates for this intake are confirmed by Admissions at enrolment.",
  },
];

export const GRADE_ROUTES = [
  { grade: "Grade 10", duration: 30, ages: "14–16" },
  { grade: "Grade 11", duration: 20, ages: "15–17" },
  { grade: "Grade 12", duration: 10, ages: "16–18" },
];

export const FAST_TRACK = {
  months: 5,
  window: "Second semester, finishing in June",
  compare: [
    { label: "Length", standard: "10 months", fast: "5 months" },
    { label: "Starts", standard: "September or January", fast: "Second semester" },
    { label: "Structure", standard: "Two semesters, 3–4 courses each", fast: "One intensive semester" },
    { label: "Diploma", standard: "OSSD", fast: "OSSD" },
    { label: "Placement", standard: "Transcripts + placement test", fast: "Transcripts + placement test, reviewed for readiness" },
  ],
};

export const SUMMER_SCHOOL_DETAILS = [
  { label: "Dates", value: "To be announced" },
  { label: "Ages", value: "To be confirmed" },
  { label: "Courses", value: "To be confirmed" },
  { label: "Day or residential", value: "To be confirmed" },
];
